import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-demo-banner',
    templateUrl: './demo-banner.component.html',
    styleUrls: ['./demo-banner.component.scss']
})
export class DemoBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
